import React from 'react';
import { Col } from 'react-bootstrap';


export const ProjectCard = ({title, description, imgUrl, link}) => {
  return (
    <Col>
        
        <div className='proj-imgbx'  >

            <img className='proj-img' src={imgUrl} alt="project_image"/>
            <a href={link}>
            <div className='proj-txtx'>
                <h4>{title}</h4>
                <span>{description}</span>
            </div>
            </a>

        </div>
        
    </Col>
  )
}
